import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalizePipe } from '../../core/pipes/localization.pipe';
import { LocalizationService } from '../../core/services/localization.service';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    imports: [LocalizePipe]
})
export class ErrorPageComponent {
  code: string;
  message: string;

  constructor(
    private readonly _localizationService: LocalizationService,
    route: ActivatedRoute
  ) {
    this.code = route.snapshot.queryParams['code'];
    if (this.code === '404') {
      this.message = this._localizationService.localize('PageNotFound');
      return;
    }

    this.message = route.snapshot.queryParams['message'];
    if (!this.message) {
      this.message = this._localizationService.localize('UnexpectedError');
    }
  }
}
